import { List } from "@mui/material";
import { type FC, useMemo } from "react";
import { PinExistingContractItem } from "web_myplann/Goals/Components/PinContract/PinExistingContractItem";
import type {
	GoalPortfolioListItemResponseDTO,
	GoalPortfolioResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

type Props = {
	portfolios: GoalPortfolioListItemResponseDTO[];
	goalPortfolios: GoalPortfolioResponseDTO[];
	pinningId: number | null;
	onSelect: (portfolio: GoalPortfolioListItemResponseDTO) => void;
};

export const PinExistingContractList: FC<Props> = ({
	portfolios,
	goalPortfolios,
	pinningId,
	onSelect,
}) => {
	const pinnedById = useMemo(
		() =>
			new Map(goalPortfolios.map((gp) => [gp.portfolioId, gp.usagePercent])),
		[goalPortfolios],
	);

	return (
		<List disablePadding>
			{portfolios.map((portfolio, portfolioIndex) => (
				<PinExistingContractItem
					key={portfolio.id}
					portfolio={portfolio}
					pinnedAllocation={pinnedById.get(portfolio.id) ?? null}
					hasDivider={portfolioIndex < portfolios.length - 1}
					isPinning={portfolio.id === pinningId}
					isBusy={pinningId !== null}
					onSelect={onSelect}
				/>
			))}
		</List>
	);
};
